import script from "./BodorCam.vue?vue&type=script&setup=true&lang=js"
export * from "./BodorCam.vue?vue&type=script&setup=true&lang=js"

import "./BodorCam.vue?vue&type=style&index=0&id=26241f05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26241f05"]])

export default __exports__